import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
// import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { LicenseManager } from '@ag-grid-enterprise/core';
// import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import { MultiFilterModule } from '@ag-grid-enterprise/multi-filter';
// import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
// import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
// import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { NgModule } from '@angular/core';
import { CdwSearchGridComponent } from './cdw-search-grid/cdw-search-grid.component';
import { ColumnVisibilityButtonComponent } from './column-visibility-button/column-visibility-button.component';
import { DeleteItemIconComponent } from './delete-item-icon/delete-item-icon.component';
import { PreviewIconComponent } from './preview-icon/preview-icon.component';

/**
 * Compatibility module for consumers still using NgModule imports.
 * CdwSearchGridComponent is now standalone - prefer importing the component directly.
 */
@NgModule({
  imports: [
    CdwSearchGridComponent,
    ColumnVisibilityButtonComponent,
    DeleteItemIconComponent,
    PreviewIconComponent,
  ],
  exports: [
    CdwSearchGridComponent,
    ColumnVisibilityButtonComponent,
    DeleteItemIconComponent,
    PreviewIconComponent,
  ],
})
export class CdwSearchGridModule {
  constructor() {
    LicenseManager.setLicenseKey(
      'Using_this_AG_Grid_Enterprise_key_( AG-041717 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Amplified It LLC )_is_granted_a_( Multiple Applications )_Developer_License_for_( 7 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 2 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 9 February 2023 )____[v2]_MTY3NTkwMDgwMDAwMA==fde3befd306bf03b02dc772150bedb3c'
    );

    ModuleRegistry.registerModules([
      ClientSideRowModelModule,
      // ClipboardModule,
      ColumnsToolPanelModule,
      // FiltersToolPanelModule,
      MenuModule,
      // MultiFilterModule,
      // RowGroupingModule,
      // SetFilterModule,
      ServerSideRowModelModule,
      // StatusBarModule,
      SideBarModule,
    ]);
  }
}
